import AddPlusIcon from "@assets/icons/AddPlusIcon"
import HistoryIcon from "@assets/icons/HistoryIcon"
import { COLLECTION_ADMINISTRATION_CODES } from "@constants/modules/collectionAdministration/collectionAdministrationCodes"
import FeatureButton from "@tcomponents/FeatureButton/FeatureButton"
import LogsDrawer from "@tcomponents/Logs/components/LogsDrawer/LogsDrawer"
import useRedirectTo from "@thooks/useRedirectTo"
import { CustomNavigate } from "@UI/CustomNavigate"
import { Row } from "antd"
import { useState } from "react"
import './styles.css'

const CollectionAdministrationHeader = () => {
  const { handleRedirectTo } = useRedirectTo()
  const [openLogsDrawer, setOpenLogsDrawer] = useState(false)

  return (
    <header>
      <CustomNavigate title={
        'ADMINISTRACIÓN DE COBROS'
      }>
        <Row className="collection-administration-header" style={{ gap: 16 }} align="middle">
          <FeatureButton
            code={COLLECTION_ADMINISTRATION_CODES.COLLECTION_ADMINISTRATION_NEW_TEMPLATE}
            onClick={() => handleRedirectTo('/administration-collection/template/new')}
            className="btn-standard-green"
            shape="round"
            icon={<AddPlusIcon />}
            tooltip="Nuevo cobro"
          >
            NUEVO COBRO
          </FeatureButton>
          <FeatureButton
            code={COLLECTION_ADMINISTRATION_CODES.COLLECTION_ADMINISTRATION_TEMPLATE_LOGS}
            className="btn-standard-white btn-feature-icon-disabled"
            style={{
              borderRadius: '50%',
              width: 42,
              height: 40,
            }}
            popoverProps={{ 
              placement: 'left',
             }}
            icon={<HistoryIcon />}
            tooltip="Historial de cambios"
            onClick={() => setOpenLogsDrawer(true)}
          />
          <LogsDrawer
            isOpen={openLogsDrawer}
            onClose={() => setOpenLogsDrawer(false)}
            redirectTo="/logs/administration-collection"
            service="/charge/log"
          />
        </Row>
      </CustomNavigate>
    </header>
  )
}

export default CollectionAdministrationHeader
